import React, {createContext, useContext, useEffect, useState} from 'react';
import {useZooPassAppContext} from "../../Context/ZooPassAppContext";
import {IZooPassAnswersContext, useZooPassAppAnswersContext, ZooPassAppAnswersContext} from "../../Context/ZooPassAnswersContext";
import {StepTitleContent} from "../PanelContents/StepTitleContent";
import {ImageAnswerComponent} from "../PanelContents/ImageAnswer";
import ZooPassLocalStateUtility from "../../Utilities/ZooPassLocalStateUtility";
import sprintf from "sprintf-js";

export const Step5SidebarValue : React.FC = () => {

    let {
        numericValues,
        loading
    } = useZooPassAppContext();

    let {
        answersData,
        answersLoading
    } = useZooPassAppAnswersContext();
    
    if(!answersLoading && !loading && numericValues !== null && answersData !== null)
    {
        const valueFormat = numericValues.get("ZooPass:ProgressValue:05:Guests");
        if(valueFormat != null && answersData.step5Value !== null){
            if(answersData.step5Value === 0){
                return(<><span>{valueFormat.format0}</span></>);
            }
            if(answersData.step5Value === 1){
                return(<><span>{valueFormat.format1}</span></>);
            }
            if(answersData.step5Value > 1 && valueFormat.formatN !== null){
                return(<><span>{sprintf.sprintf(valueFormat.formatN, answersData.step5Value)}</span></>);
            }
        }
    }
    
    return(<><span>&nbsp;</span></>);
};

